import {DataStatus} from 'platform/components';

import {lazy, Suspense} from 'react';

const Charts = lazy(() => import('./Charts').then((module) => ({default: module.Charts})));

export function WarehouseCharts() {
  return (
    <Suspense fallback={<DataStatus minHeight={100} isLoading />}>
      <Charts />
    </Suspense>
  );
}
